import axios, { AxiosInstance } from 'axios'

const httpExterno: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 120000
})

export default httpExterno
